module.exports = __webpack_public_path__ + "img/Materializecss.fe397f2a.svg";